import { useEffect } from "react";

import {
  BarChart as ReBarChart,
  Bar,
  CartesianGrid,
  ResponsiveContainer,
  LabelList,
} from "recharts";

import { COLORS } from "../../../../../theme/colors";
import { TooltipContent } from "../../../../../components/charts/TooltipContent";
import { Tooltip } from "../../../../../components/charts/Tooltip";

export const BarChartForEmissionImpact = ({
  chartData,
  barColors,
  customLabelList,
  additionalBars,
  unit,
}) => {
  const BAR_SIZE = 20;

  useEffect(() => {
    if (!additionalBars) return;
    setTimeout(() => {
      for (let i = 0; i < additionalBars.length; i++) {
        const className = additionalBars[i].key;
        const tags = document.getElementsByClassName(
          `recharts-rectangle ${className}`
        );
        if (tags.length) {
          for (const tag of tags) {
            const d = tag.getAttribute("d");
            const x = parseInt(d.split(" ")[1].split(",")[0]);
            tag.setAttribute(
              "d",
              `M ${x + BAR_SIZE * (i + 1)},${d.split(",")[1]}`
            );
          }
        }
      }
    }, 800);
  }, []);

  return (
    <ResponsiveContainer width="100%" height={170}>
      <ReBarChart
        data={chartData}
        margin={{
          top: 20,
          bottom: 5,
        }}
        barSize={BAR_SIZE}
      >
        <CartesianGrid vertical={false} strokeDasharray="5 2" />
        <Tooltip chartData={chartData} content={<TooltipContent />} />
        <Bar
          dataKey="trading"
          stackId="a"
          fill={barColors && barColors[0] ? barColors[0] : COLORS.purple}
          unit={unit}
        />
        <Bar
          dataKey="battery"
          stackId="a"
          fill={barColors && barColors[1] ? barColors[1] : "#4F31CF"}
          unit={unit}
        />
        <Bar
          dataKey="ev"
          stackId="a"
          fill={barColors && barColors[2] ? barColors[2] : COLORS.cian}
          unit={unit}
        />
        {additionalBars &&
          additionalBars.map((additionalBar, index) => (
            <Bar
              key={index}
              dataKey={additionalBar.key}
              stackId="a"
              fill={additionalBar.color}
              className={additionalBar.key}
              unit={unit}
            >
              {index === additionalBars.length - 1 && customLabelList && (
                <LabelList
                  dataKey="total"
                  content={customLabelList}
                  position="top"
                  offset={10}
                />
              )}
            </Bar>
          ))}
      </ReBarChart>
    </ResponsiveContainer>
  );
};
